<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Corporate Action'}}</strong>
        </div>
        <div class="col-md-2">
          <download :tableId="'corporate-action'" :fileName="'corporate-action'"></download>
        </div>
        <!-- <div class="col-md-1">
          <goback></goback>
        </div>-->
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-9 br">
          <div class="form-group">
            <!-- <v-select
              :options="companyList"
              :placeholder="'Select Company'"
              :label="'companyname'"
              v-model="selComp"
              @input="getCompData"
            >
            </v-select>-->
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              type="text"
              v-model="searchText"
              class="form-control"
              name="search"
              placeholder="Search"
              @keyup="search($event)"
            />
          </div>
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table
          id="corporate-action"
          class="table table-sm first-td-padding table-bordered app-inner"
        >
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
              <th v-if="actions.length>0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in fillableData" v-bind:key="'row'+index">
              <td>
                <span>{{(index+1)}}</span>
                <!-- <span>{{(index+1)+(perPage*($refs.page.current_page-1))}}</span> -->
              </td>
              <td v-for="field in tableFields" v-bind:key="field.name+index">
                <span v-if="field.name==='date'">{{getDateTime(row[field.name])}}</span>
                <span
                  v-else-if="field.name==='name'"
                >{{(row['first_name'])? row['first_name'] + ' ' + row['last_name']: '-'}}</span>
                <span v-else>{{row[field.name]}}</span>
              </td>
              <td v-if="actions.length>0">
                <div class="action-btn-wrapper">
                  <a
                    style="margin:1px 4px"
                    class="btn btn-sm btn-small"
                    :class="action.btnClass"
                    v-for="action in actions"
                    v-bind:key="'action'+action.tooltip"
                    @click.prevent="action.callback(row,index,$event)"
                  >
                    <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+actions.length+1)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";

export default {
  mixins: [commonMixins],
  name: "CorporateActionReport",
  created() {
    this.url = this.apiUrl;
    this.fetchData();
  },
  data() {
    return {
      apiUrl: "get/corporateAction",
      pageType: "corporate-action",
      actions: [
        // {
        //   btnClass: "btn-info",
        //   icon: "fa-eye cwhite",
        //   callback: this.viewUsers,
        //   tooltip: "View Users"
        // }
      ],
      tableFields: [
        {
          name: "co_code",
          title: "Company Code"
        },
        {
          name: "co_name",
          title: "Company"
        },
        {
          name: "val",
          title: "Action"
        },
        {
          name: "date",
          title: "Date"
        }
      ],
      fillableData: [],
      searchData: [],
      searchText: '',
      url: ""
    };
  },
  methods: {
    search(e) {
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.fillableData = this.searchData.filter(field => {
          console.log("export field", field);
          return (
            field.co_name.toLowerCase().includes(this.searchText.toLowerCase()) ||
            field.val.toLowerCase().includes(this.searchText.toLowerCase())
          );
        });
      }
      if (
        this.searchText === null ||
        this.searchText === "" ||
        this.searchText.length <= 2
      ) {
        this.fillableData = this.searchData;
        return this.fillableData;
      }
    },
    fetchData(data = null) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        http.get(this.apiUrl, {}, function(error, response) {
          console.log(response);
          myself.fillableData = response;
          myself.searchData = myself.fillableData;
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/reports/corporate-action.vue